import React, { useState, useEffect } from 'react';

function ResultScreen({ outcome, geniusFlags, onRestart, onBackToSelect }) {
  const [visible, setVisible] = useState(false);
  const [showRewards, setShowRewards] = useState(false);

  const isVictory = outcome.type !== 'defeat';
  const isBest = outcome.type === 'bestVictory';
  const isPartial = outcome.type === 'partialVictory';
  const xpReward = outcome.rewards.find(r => r.type === 'xp');
  const badges = outcome.rewards.filter(r => r.type === 'badge');
  const items = outcome.rewards.filter(r => r.type === 'item');

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 200);
    const t2 = setTimeout(() => setShowRewards(true), 1200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const resultClass = isBest ? 'result-best' : isVictory ? 'result-victory' : 'result-defeat';
  const iconChar = isBest ? '\u{1F511}' : isVictory ? '\uD83D\uDD13' : isPartial ? '\u26A0\uFE0F' : '\uD83D\uDD12';

  return (
    <div className={`result-screen ${resultClass} ${visible ? 'result-visible' : ''}`}>
      <div className="result-flash" />

      <div className="result-content">
        <div className="result-icon">{iconChar}</div>
        <div className="result-subtitle">{outcome.subtitle}</div>
        <h1 className="result-title">{outcome.title}</h1>
        <p className="result-message">{outcome.message}</p>

        {showRewards && outcome.rewards.length > 0 && (
          <div className="result-rewards">
            <div className="rewards-header">REWARDS</div>

            {xpReward && (
              <div className="reward-card reward-xp">
                <span className="reward-icon-char">&olarr;</span>
                <span className="reward-value">+{xpReward.amount} XP</span>
              </div>
            )}

            {items.map((item, i) => (
              <div key={`item-${i}`} className="reward-card reward-item">
                <span className="reward-icon-char">{item.icon}</span>
                <div className="reward-info">
                  <span className="reward-name">{item.name}</span>
                  <span className="reward-desc">{item.description}</span>
                </div>
              </div>
            ))}

            {badges.map((badge, i) => (
              <div key={`badge-${i}`} className="reward-card reward-badge">
                <span className="reward-icon-char">{badge.icon}</span>
                <div className="reward-info">
                  <span className="reward-name">{badge.name}</span>
                  <span className="reward-desc">{badge.description}</span>
                </div>
              </div>
            ))}

            {geniusFlags.length > 0 && (
              <div className="reward-card reward-genius">
                <span className="reward-icon-char">&#x1F9E0;</span>
                <div className="reward-info">
                  <span className="reward-name">GENIUS FLAG: {geniusFlags.join(', ')}</span>
                  <span className="reward-desc">Your unconventional thinking has been noticed by the system.</span>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="result-actions">
          <button className="btn-primary btn-restart" onClick={onRestart}>
            {isVictory ? 'PLAY AGAIN' : 'TRY AGAIN'}
          </button>
          {onBackToSelect && (
            <button className="btn-primary btn-back-to-select" onClick={onBackToSelect}>
              BACK TO MISSIONS
            </button>
          )}
        </div>

        <div className="result-profile-hint">
          Your behavioral profile has been saved to the Genius Engine.
        </div>
      </div>
    </div>
  );
}

export default ResultScreen;
